const route = {
	name: 'reference-guides',
	path: '/reference-guides',
	redirect: '/reference-guides/list',
	component: () => import('@/components/reference-guides/reference-guides'),
	children: [
		{
			name: 'list-of-guides',
			path: 'list',
			meta: {
				title: 'GUÍAS DE REMISIÓN',
			},
			component: () => import('@/components/reference-guides/list-of-guides'),
		},
		{
			name: 'reference-guide-detail',
			path: ':id?/detail/:saleId?',
			meta: {
				title: 'GUÍA DE REMISIÓN',
			},
			props: true,
			component: () => import('@/components/reference-guides/detail'),
		},
		{
			name: 'reference-guide-view',
			path: ':id?/view',
			meta: {
				title: 'DETALLE GUÍA DE REMISIÓN',
			},
			props: true,
			component: () => import('@/components/reference-guides/view'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/reference-guides.js